// Angular
import { Component, Input, OnChanges } from '@angular/core';

// Afidium
import { IGetBookingsStayResponse, ISectorStay } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { ITableSectorServices, ITableConfigGetterInput, TableServicesService } from '../../shared/services/table-services/table-services.service';
import { IServicesTableConfig } from '../../shared/components/services-table/IServicesTableConfig';

@Component({
    selector: 'sector-stay-services',
    template: `<services-table *ngIf="servicesTableConfig" [tableConfig]="servicesTableConfig"></services-table>`,
    styles: [`
        services-table ::ng-deep .mat-row mat-cell.mat-cell {
            display: unset;
        }
    `]
})
export class SectorStayServicesComponent implements OnChanges {
    @Input()
    public booking: IGetBookingsStayResponse;

    @Input()
    public sector: ISectorStay;

    @Input()
    public tableServices: ITableSectorServices;

    public servicesTableConfig: IServicesTableConfig;

    constructor(
        private readonly tableServicesService: TableServicesService,
    ){}

    public ngOnChanges(): void{
        if(this.booking){
            this.init();
        }
    }

    private init(): void{
        this.servicesTableConfig = this.getTableConfig();
    }

    private getTableConfig(): IServicesTableConfig | null {
        if(this.tableServices){
            const tableConfigGetter: ITableConfigGetterInput = {
                ...this.tableServices,
                sectorXId: this.sector.xId,
                type: this.sector.xType
            };

            return this.tableServicesService.getSectorTableConfig(tableConfigGetter);
        }
        return null;
    }
}
